<template>
  <div style="margin-top: 25px;">
    <div>
      <button id="startRecording" @click="handleStartRecordingClick">
        Start
      </button>
      <button id="stopRecording">Stop</button>
      <br />
      <p id="isRecording">Click start button to record</p>
      <audio src=""
             id="audioElement"
             controls
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "REsourceBlocks_AudioRecorder",
  components: {
  },
  props: {},
  created() {},
  mounted() {
    this.handlePrepareRecorder();
  },
  computed: {},
  methods: {
    handleStartRecordingClick() {
      this.isRecording = document.getElementById("isRecording");
    },
    handlePrepareRecorder(){
      document
          .getElementById("startRecording")
          .addEventListener("click", this.initFunction);
      this.isRecording = document.getElementById("isRecording");
    },
    async getUserMedia(constraints) {
      if (window.navigator.mediaDevices) {
        return window.navigator.mediaDevices.getUserMedia(constraints);
      }
      let legacyApi =
          navigator.getUserMedia ||
          navigator.webkitGetUserMedia ||
          navigator.mozGetUserMedia ||
          navigator.msGetUserMedia;
      if (legacyApi) {
        return new Promise(function (resolve, reject) {
          legacyApi.bind(window.navigator)(constraints, resolve, reject);
        });
      } else {
        alert("user api not supported");
      }
    },
    handlerFunction(stream) {
      this.rec = new MediaRecorder(stream);
      this.rec.start();
      this.rec.ondataavailable = (e) => {
        this.audioChunks.push(e.data);
        if (this.rec.state == "inactive") {
          let blob = new Blob(this.audioChunks, { type: "audio/mp3" });
          console.log(blob);
          document.getElementById("audioElement").src = URL.createObjectURL(blob);
        }
      };
    },
    startusingBrowserMicrophone(boolean) {
      this.getUserMedia({ audio: boolean })
          .then((stream) => {
        this.handlerFunction(stream);
      }).catch((e)=>{
        console.error(e);
      });
    },
    initFunction() {
      // Display recording
      this.isRecording.textContent = "Recording...";
      //
      this.startusingBrowserMicrophone(true);
      // Stoping handler

      let that = this;
      document.getElementById("stopRecording").addEventListener("click", (e) => {
        that.rec.stop();
        that.isRecording.textContent = "Click play button to start listening";
      });
    }
  },
  data() {
    return {
      rec: null,
      isRecording: null,
      audioChunks: []
    };
  }
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
button {
  padding: 7px 20px;
  cursor: pointer;
}
</style>
